import {useCurrentHiveStore} from "entities/currentHive";
import {Button} from "@atomaro/ui-kit";
import {toast} from "react-toastify";
import {FC, useState} from "react";
import {SubmitModal} from "widgets/SubmitModal";

type HiveBodyArchiveProps ={
    isScreenLg: boolean
}

export const HiveBodyArchive:FC<HiveBodyArchiveProps>= ({isScreenLg}) => {
    const isArchived = useCurrentHiveStore(s => s.currentHive?.deletedAt);
    const deleteHive = useCurrentHiveStore(s => s.deleteHive);
    const restoreHive = useCurrentHiveStore(s => s.restoreHive);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const onConfirm = async () => {
        try {
            if (isArchived) {
                await restoreHive();
                toast.success("Улей восстановлен из архива");
            } else {
                await deleteHive();
                toast.success("Улей перенесён в архив");
            }
        } catch {
            toast.error("Ошибка при изменении статуса улья");
        } finally {
            setIsOpenModal(false);
        }
    };

    return (
        <>
            <Button
                style={{
                    margin: isScreenLg ? "0 auto 0 0" : "0 auto",
                }}
                variant={"ghost"}
                onClick={() => setIsOpenModal(true)}
                label={isArchived ? "Вынести улей из архива" : "Перенести улей в архив"}
            />
            <SubmitModal
                isOpen={isOpenModal}
                onClose={() => setIsOpenModal(false)}
                onConfirm={onConfirm}
                title={isArchived ? "Вы уверены, что хотите вернуть улей из архива?" : "Вы уверены, что хотите перенести улей в архив?"}
                subtitle={isArchived ? "" : ""}
            />
        </>
    );
};
